import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Navigation {
    constructor (element) {
        this.$navigation = element;
        this.$mainNavigation = this.$navigation.querySelector('[data-siteheader="main-nav"]');
        this.$bookmarks = this.$navigation.querySelector('[data-siteheader="bookmarks"]');
        this.$menuCheckbox = this.$navigation.querySelector('[id="menu-toggle"]');
        this.$$menuToggle = this.$navigation.querySelectorAll('[data-for-checkbox="menu-toggle"]');
        this.$bookmarksCheckbox = this.$navigation.querySelector('[id="bookmarks-toggle"]');
        this.$$bookmarksToggle = this.$navigation.querySelectorAll('[data-for-checkbox="bookmarks-toggle"]');
        this.$navigationScroller = this.$navigation.querySelector('[data-siteheader="scroller"]');
        this.$bookmarksScroller = this.$navigation.querySelector('[data-bookmark-scroller="root"]');
    }

    initialize () {
        if (this.$navigation) {
            this.setEvents();
        }
    }

    setEvents () {
        if (this.$$menuToggle.length > 0) {
            this.$$menuToggle.forEach($menuToggle => {
                this.activeEvent($menuToggle, this.$menuCheckbox, this.$bookmarksCheckbox, this.$mainNavigation, this.$mainNavigation.querySelector('[data-for-checkbox="menu-toggle"]'), this.$navigationScroller);
            });
        }

        if (this.$$bookmarksToggle.length > 0) {
            this.$$bookmarksToggle.forEach($bookmarksToggle => {
                this.activeEvent($bookmarksToggle, this.$bookmarksCheckbox, this.$menuCheckbox, this.$bookmarks, this.$bookmarks.querySelector('[data-for-checkbox="bookmarks-toggle"]'), this.$bookmarksScroller);
            });
        }
    }

    activeEvent (currentToggle, currentCheckbox, otherCheckbox, activeNav, focusElement, $scrollContainer) {
        currentToggle.addEventListener('click', () => {
            if (currentCheckbox.checked === false) {
                if (otherCheckbox.checked === true) {
                    otherCheckbox.checked = false;
                }

                this.$navigation.classList.add('has--menu-open');

                setTimeout(() => {
                    focusElement.focus();
                }, 200);

                disableBodyScroll($scrollContainer);
                this.handleOutsideTab(activeNav, currentCheckbox, currentToggle, $scrollContainer);
            } else {
                this.closeNavigation();
            }
        });
    }

    handleOutsideTab (activeNav, currentCheckbox, currentToggle) {
        document.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' || event.code === 'Tabs') {
                if (!activeNav.contains(event.target) && currentCheckbox.checked === true) {
                    currentCheckbox.checked = false;
                    currentToggle.setAttribute('aria-pressed', 'false');
                    this.closeNavigation();
                }
            }
        });
    }

    closeNavigation () {
        this.$navigation.classList.remove('has--menu-open');
        enableBodyScroll(this.$bookmarksScroller);
        enableBodyScroll(this.$navigationScroller);
    }
}

export { Navigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $navigation = $context.querySelector('[data-header="root"]');
        if ($navigation) {
            const navigation = new Navigation($navigation);
            navigation.initialize();
        }
    }
});
